import service from '@/store/services/settings/village-service';

const state = {
    list: {},
    village: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, village) => {
        state.village = village;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(village => {
                commit('SET_RESOURCE', village);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(village => {
                commit('SET_RESOURCE', village);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((village) => {
                commit('SET_RESOURCE', village);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((village) => {
                commit('SET_RESOURCE', village);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    village: state => state.village,
    dropdown: (state) => {
        return state.list.map(village => ({
            id: village.id,
            name:village.name,
            short_name: village.short_name
        }));
    }
};

const villages = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default villages;
